import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import userPlaceholder from "../../../assets/images/placeholder.jpg";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../../components/shared/Loader";
import { updateMeta } from "../../../store/actions/metaAction";

const MainImag = () => {
	const auth = useSelector(state => state.auth.user);
	const history = useHistory();
	const [picture, setPicture] = useState(userPlaceholder);
	const [picture2, setPicture2] = useState(userPlaceholder);
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "اضافة صورة عامة",
				breadcrumb: "عالم السيارات",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
        setLoading(true);
		axios
			.get(`${process.env.REACT_APP_API_URL}/posts/${411}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then((response) => {
				setPicture(response.data?.data?.data?.image?.ar);
				setPicture2(response.data?.data?.data?.image?.en);
				console.log(response.data);

				setLoading(false);
			})
			.catch((error) => {
				console.log(error);
				setLoading(false);
			});

	};

	const handlePicture = (e) => {
		e.preventDefault();
		const fileInput = document.querySelector("#picture");


		if (fileInput.files[0]) {
			const data = new FormData();
			data.append("file", fileInput.files[0]);
			axios
				.post(`${process.env.REACT_APP_API_URL}/upload`, data, {
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
						"Content-Type": "multipart/form-data",
					},
				}).then(response => {
					setPicture(response.data.data.name);
					setLoading(false);
					toast.success("تم رفع الصورة بنجاح!");
				}).catch(error => {
					console.log(error);
					toast.error("خطأ في رفع الصورة، برجاء المحاولة مرة أخرى!");
					setLoading(false);
				});
		}
	};
	const handlePicture2 = (e) => {
		e.preventDefault();
		const fileInput = document.querySelector("#picture2");

		if (fileInput.files[0]) {
			const data = new FormData();
			data.append("file", fileInput.files[0]);
			axios
				.post(`${process.env.REACT_APP_API_URL}/upload`, data, {
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
						"Content-Type": "multipart/form-data",
					},
				}).then(response => {
					setPicture2(response.data.data.name);
					setLoading(false);
					toast.success("تم رفع الصورة بنجاح!");
				}).catch(error => {
					console.log(error);
					toast.error("خطأ في رفع الصورة، برجاء المحاولة مرة أخرى!");
					setLoading(false);
				});
		}
	};
	const handleSubmit = e => {
		e.preventDefault();
		if (picture && picture2) {
			setLoading(true);


			const data = {
				image: {
					ar: picture,
					en: picture2
				}
			};
			axios
				.put(
					`${process.env.REACT_APP_API_URL}/posts/${411}`,
					{
						admin_id: auth.id,
						category_id: 59,
						data: data,
					},
					{
						headers: {
							Authorization: `Bearer ${cookie.get("token")}`,
							Accept: "application/json",
						},
					}
				)
				.then(function (response) {

					toast.success("تم اضافة الصور بنجاح!");
					setLoading(false);
				})
				.catch(function (error) {
					toast.error("خطأ، برجاء المحاولة مره اخرى!");
					setLoading(false);
				});


		} else {
			toast.error("برجاء اختيار الصورة أولا!");
		}
	};

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit}>
				<div className="row">
					<div className="row mx-auto">
						<div className="form-item col-12 col-md-6">
							<label>صورة عربي</label>
							<input type="file" onChange={handlePicture} id="picture" />
							<div className="img-holder">
								<img src={picture ? process.env.REACT_APP_MAIN_URL + picture : userPlaceholder} alt="avatar" className="imagePreview" />
							</div>
						</div>
						<div className="form-item col-12 col-md-6">
							<label>صورة انجليزي</label>
							<input type="file" onChange={handlePicture2} id="picture2" />
							<div className="img-holder">
								<img src={picture2 ? process.env.REACT_APP_MAIN_URL + picture2 : userPlaceholder} alt="avatar" className="imagePreview" />
							</div>
						</div>
						<div className="form-item">
							<button type="submit" className="bt bt-success btn-block">ارسال</button>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default MainImag;
